import { render, staticRenderFns } from "./DialogueAudioExtractor.vue?vue&type=template&id=ff6b06ae&scoped=true&"
import script from "./DialogueAudioExtractor.vue?vue&type=script&lang=js&"
export * from "./DialogueAudioExtractor.vue?vue&type=script&lang=js&"
import style0 from "./DialogueAudioExtractor.vue?vue&type=style&index=0&id=ff6b06ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6b06ae",
  null
  
)

export default component.exports